import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider, FormControl, InputLabel, Select, MenuItem, FormHelperText, Tooltip } from '@mui/material';
import { createDebouncedUpdate, updateCellProperty } from '../utils/InspectorUtils';

export function renderSelectBox(field, cell, theme, modules = []) {
  const container = document.createElement('div');

  const SelectBoxField = () => {
    const getInitialValue = () => {
      const fromCell = cell.get(field.path);
      if (fromCell !== undefined && fromCell !== null) return fromCell;
      if (field.defaultValue !== undefined) return field.defaultValue;
      return '';
    };

    const [value, setValue] = React.useState(getInitialValue);

    const [debouncedValue] = React.useState(() =>
      createDebouncedUpdate((newValue) => {
        updateCellProperty(cell, field, field.path, newValue);
      })
    );

    React.useEffect(() => {
      const existing = cell.get(field.path);
      if (existing === undefined && field.defaultValue !== undefined) {
        updateCellProperty(cell, field, field.path, field.defaultValue);
        setValue(field.defaultValue);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = (e) => {
      let newValue = e.target.value;

      const isModuleField =
        field.path === 'module' || field.path === 'moduleForBaggageRoutingRule' || field.path === 'unloadingModule';

      if (!isModuleField) {
        if (typeof field.defaultValue === 'boolean') {
          newValue = newValue === 'true' || newValue === true;
        } else if (typeof field.defaultValue === 'number') {
          newValue = Number(newValue);
        }
      }

      setValue(newValue);
      debouncedValue(newValue);
    };

    React.useEffect(
      () => () => {
        debouncedValue.cancel();
      },
      [debouncedValue]
    );

    let fieldOptions = typeof field.options === 'function' ? field.options() : (field.options ?? []);

    const isModuleField =
      field.path === 'module' || field.path === 'moduleForBaggageRoutingRule' || field.path === 'unloadingModule';

    if (isModuleField) {
      fieldOptions = modules.map((moduleName) => ({
        key: moduleName,
        value: moduleName,
        label: moduleName,
      }));

      if (value && !fieldOptions.some((o) => o.value === value)) {
        fieldOptions = [{ key: '__current__', value, label: value }, ...fieldOptions];
      }
    }

    const selectValue = value === undefined || value === null ? '' : value;

    return (
      <ThemeProvider theme={theme}>
        <FormControl
          fullWidth
          size="small"
          required={field.required}
          error={field.required && (selectValue === '' || selectValue === undefined || selectValue === null)}
        >
          <InputLabel>{field.label}</InputLabel>
          <Select
            value={selectValue}
            onChange={field.readOnly ? undefined : handleChange}
            label={field.label}
            variant="outlined"
            disabled={field.readOnly}
            inputProps={{
              'data-cy': field.attributes?.['data-cy'],
              onCompositionStart: (e) => e.stopPropagation(),
              onCompositionEnd: (e) => e.stopPropagation(),
            }}
            MenuProps={{
              disablePortal: true,
              PaperProps: {
                style: { zIndex: 2000 },
              },
            }}
          >
            {fieldOptions.map((option) => (
              <MenuItem key={option.key ?? option.value} value={option.value}>
                <Tooltip title={option.tooltip ?? ''} placement="right" arrow>
                  <span style={{ width: '100%' }}>{option.label ?? option.content ?? option.value}</span>
                </Tooltip>
              </MenuItem>
            ))}
          </Select>
          {field.required && (selectValue === undefined || selectValue === '') && (
            <FormHelperText>Ce champ est requis</FormHelperText>
          )}
        </FormControl>
      </ThemeProvider>
    );
  };

  ReactDOM.render(<SelectBoxField />, container);
  return container;
}
